import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';
import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Heatmap, NewHeatmap} from '../../_types/polls';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {debounceTime} from 'rxjs';

@Component({
    selector: 'app-create-heatmap',
    templateUrl: './create-heatmap.component.html',
    styleUrl: './create-heatmap.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CreateHeatmapComponent {
    formGroup: FormGroup = this.fb.group({
        title: this.fb.control('', Validators.required),
        image: this.fb.control(null, Validators.required),
        description: this.fb.control(''),
        end_at: this.fb.control(null),
        options: this.fb.array([]),
        maximum_votes: this.fb.control(1)
    });
    color: Map<number, string> = new Map([[0, '#a8ff00'], [1, '#f200bd'], [2, '#2889e9'], [3, '#e920e9'], [4, '#fff500']]);
    initialImage: any;
    initialId!: number;
    @Output() isValidPollData: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() pollData: EventEmitter<NewHeatmap> = new EventEmitter<NewHeatmap>();

    constructor(
        private readonly fb: FormBuilder,
    ) {
        this.formGroup.statusChanges.pipe(takeUntilDestroyed()).subscribe(res => {
            this.isValidPollData.emit(res === 'VALID' || res === 'DISABLED');
        });
        this.formGroup.valueChanges.pipe(
            debounceTime(200),
            takeUntilDestroyed()
        ).subscribe((): void => {
            this.pollData.emit({...this.formGroup.value, id: this.initialId});
        });


        this.addOption();
        this.addOption();
        this.options?.controls.forEach((control, i): void => {
            this.onChangeColor(this.color.get(i) || '#fff', i);
        })
        this.formGroup.updateValueAndValidity({onlySelf: false});
    }

    @Input() set initialPollData(value: Heatmap | undefined) {
        if (!value) return;
        this.initialImage = [{file: (value as Heatmap).image, attachment_type: 'image', id: 'heatmapImage'}];
        this.initialId = value.id;
        Array.from({length: value.options.length - 2}, (): void => this.addOption());
        this.formGroup.patchValue(value);
        this.formGroup.disable({onlySelf: false});
        this.formGroup.get('end_at')!.enable();
        this.formGroup.get('maximum_votes')!.enable();
        this.formGroup.updateValueAndValidity();
    };

    get options(): FormArray {
        return this.formGroup.get('options') as FormArray;
    }

    getAttachmentField(event: any): void {
        this.formGroup.get('image')?.setValue(event.value);
        this.formGroup.updateValueAndValidity();
    }

    removeOption(i: number): void {
        this.options.removeAt(i);
    }

    addOption(): void {
        this.options.push(this.newOption());
    }

    onChangeColor(event: string, i: number): void {
        this.color.set(i, event);
        this.options.at(i).get('color')?.setValue(event);
    }

    private newOption(): FormGroup {
        return this.fb.group({
            text: this.fb.control('', Validators.required),
            color: this.fb.control(this.color.get(this.options.length) || '#fff', Validators.required)
        });
    }
}
